import script from "./aftersale-settlement.vue?vue&type=script&lang=ts&setup=true"
export * from "./aftersale-settlement.vue?vue&type=script&lang=ts&setup=true"

import "./aftersale-settlement.vue?vue&type=style&index=0&id=4db40390&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db40390"]])

export default __exports__